var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchesWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.62271,5 L21.638741,11.5594321 L15.62271,18.1188642 L13.612,15.926 L11.5874595,18.1343249 L9.794,16.179 L8.01603096,18.1188642 L2,11.5594321 L8.01603096,5 L9.808,6.954 L9.179,7.64 L8.01603096,6.37241434 L3.25871981,11.5594321 L8.01603096,16.7464499 L9.165,15.493 L5.57142857,11.5748928 L11.5874595,5.01546073 L13.598,7.207 L15.62271,5 Z M11.5874595,6.38787507 L6.83014838,11.5748928 L11.5874595,16.7619106 L12.982,15.24 L9.60667904,11.5594321 L12.968,7.893 L11.5874595,6.38787507 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchesWhiteIcon);
export default __webpack_public_path__ + "static/media/BatchesWhiteIcon.95d6b8827f53f834ebda8b6758d174e5.svg";
export { ForwardRef as ReactComponent };